export const SUBMISSION_STATUS_ID = {
  PENDING:0,
  DENIED:1,
  APPROVED:2,
  SENT:3
}